import { TurnSchedule } from "../pages/AttendancePage/SelectedTypeHour/SelectedTypeHour";
import parseToMs from "./parseToMs";

export default function sortScheduleByPriority(schedules: TurnSchedule[]) {
  const nowMs = Date.now();

  const enriched = schedules.map((t) => ({
    ...t,
    start: parseToMs(t.hora_entrada, new Date(nowMs)),
    end: parseToMs(t.hora_salida, new Date(nowMs)),
  }));

  return enriched.sort((a, b) => {
    const prioridad = (est: 1 | 2 | 3) => {
      if (est === 2) return 1;
      if (est === 1) return 2;
      return 3;
    };

    const pa = prioridad(a.estatus);
    const pb = prioridad(b.estatus);
    if (pa !== pb) return pa - pb;

    if (a.estatus === 2 && b.estatus === 2) {
      return b.start - a.start;
    }

    if (a.estatus === 1 && b.estatus === 1) {
      return a.start - b.start;
    }

    if (a.estatus === 3 && b.estatus === 3) {
      return b.start - a.start;
    }

    return a.start - b.start;
  });
}
